import React from "react";

// Utils

// Components
import { Fade, MenuItem, Popover } from "@mui/material";

// Types
import { SimpleMenuDataModel } from "@brz-types/navigation.type";
import { TextLink } from "@brz-components/elements/text.link";
import { addClassObjects, Config, useClass } from "@breezerr";
import { Img } from "@brz-components/elements/img";
import { newLinesToBreaks } from "@brz-utils/newlines.to.breaks";



type SImpleMenuProps = {
    show: boolean;
    anchorEl: HTMLElement | null;
    onClose(): void;
    data: SimpleMenuDataModel;
};


addClassObjects({
    breakpoint: '',
    rule: {
        '.brzSimpleMenuItem:hover': {
            backgroundColor: Config.colors.secondary[300][0]
        },
        '.brzSimpleMenuItem:hover .brzSimpleMenuItemIconWrap': {
            backgroundColor: 'white !important'
        },
        '.brzSimpleMenuItem:hover .brzSimpleMenuItemTypeText': {
            color: Config.colors.secondary[1100][0]
        }
    }
}, '');


export const SimpleMenu = (props: SImpleMenuProps) => {
    const { data } = props;

    return (
        <Popover
            anchorEl={props.anchorEl}
            open={props.show}
            onClose={() => {
                if ( typeof props.onClose === 'function' ) {
                    props.onClose();
                }
            }}
            TransitionComponent={Fade}
            anchorOrigin={{
                horizontal: 'center',
                vertical: 'bottom'
            }}
            transformOrigin={{
                horizontal: 'center',
                vertical: 'top'
            }}
            PaperProps={{
                elevation: 3,
                sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    marginTop: '2rem',
                    padding: '1.5rem 0',
                    borderRadius: '2rem',
                    pointerEvents: 'auto'
                }
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        background: 'transparent'
                    }
                }
            }}
            hideBackdrop
            disableScrollLock
            sx={{
                pointerEvents: 'none'
            }}
        >{
            data.items.map((item, index) => {
                return (
                    <MenuItem
                        key={index}
                        component={TextLink}
                        href={item.link}
                        className={`brzSimpleMenuItem ${useClass('align-items-start pr-6rem')}`}
                    >
                        <span className={`brzSimpleMenuItemIconWrap ${useClass('d-block w-3.6rem h-3.6rem mr-1.5rem bg-color-grey:200 radius-1rem of-hidden') }`}>
                            <Img src={item.icon} width={36} height={36} alt={`${item.title} Icon`} />
                        </span>

                        <span className={useClass('d-flex flex-column')}>
                            <span className={`brzSimpleMenuItemTypeText ${useClass('text-size-1.3rem text-color-primary:400 lh-1.5rem mb-0.5rem')}`}>{ item.type }</span>
                            <span className={useClass('text-size-1.5rem text-800 text-color-primary:800 -ls-0.02rem lh-2rem')} dangerouslySetInnerHTML={{ __html: newLinesToBreaks(item.title) }}></span>
                        </span>
                    </MenuItem>
                )
            })
        }</Popover>
    );
};